import React, { useState, useEffect } from 'react';
import { getRecentBookings } from '../services/BookingService';
import './admin.css';

const AdminNotifications = () => {
    const [notifications, setNotifications] = useState([]);
    const [loading, setLoading] = useState(true);
    const [isOpen, setIsOpen] = useState(false);
    const [unreadCount, setUnreadCount] = useState(0);

    useEffect(() => {
        fetchRecentBookings();
        // Refresh notifications every minute
        const interval = setInterval(fetchRecentBookings, 60000);
        return () => clearInterval(interval);
    }, []);

    const fetchRecentBookings = async () => {
        try {
            setLoading(true);
            const bookings = await getRecentBookings(5); // Get 5 most recent bookings

            setNotifications(bookings);
            // Count unread notifications (newest bookings in last 24 hours)
            const oneDayAgo = new Date();
            oneDayAgo.setDate(oneDayAgo.getDate() - 1);

            const newCount = bookings.filter(booking =>
                new Date(booking.bookingDate) > oneDayAgo
            ).length;

            setUnreadCount(newCount);
            setLoading(false);
        } catch (error) {
            console.error("Error fetching recent bookings:", error);
            setLoading(false);
        }
    };

    const toggleNotifications = () => {
        setIsOpen(!isOpen);
        if (!isOpen) {
            // Mark as read when opening
            setUnreadCount(0);
        }
    };

    const formatDate = (dateString) => {
        const options = {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        };
        return new Date(dateString).toLocaleDateString(undefined, options);
    };

    return (
        <div className="admin-notifications">
            <button
                className="notification-button"
                onClick={toggleNotifications}
            >
                <i className="fas fa-bell"></i>
                {unreadCount > 0 && (
                    <span className="notification-badge">{unreadCount}</span>
                )}
            </button>

            {isOpen && (
                <div className="notification-dropdown">
                    <h3>New Bookings</h3>
                    {loading ? (
                        <p>Loading...</p>
                    ) : notifications.length > 0 ? (
                        <ul className="notification-list">
                            {notifications.map((booking) => (
                                <li key={booking.id} className="notification-item">
                                    <div className="notification-content">
                                        <strong>{booking.userName}</strong> booked
                                        <strong> {booking.eventName}</strong>
                                        <div className="notification-time">
                                            {formatDate(booking.bookingDate)}
                                        </div>
                                    </div>
                                </li>
                            ))}
                        </ul>
                    ) : (
                        <p>No recent bookings</p>
                    )}
                    <div className="notification-footer">
                        <a href="/admin/bookings">View all bookings</a>
                    </div>
                </div>
            )}
        </div>
    );
};

export default AdminNotifications; 